import config from '../config';

const useOneTrustCookieBanner = () => {
  return config.USE_ONETRUST_COOKIE_BANNER === 'true';
};

export default useOneTrustCookieBanner;
